"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropagationModel = exports.RelativeRSSIProcessing = void 0;
const data_1 = require("../data");
const core_1 = require("@openhps/core");
/**
 * Relative RSSI processing node to convert [[RelativeRSSI]] to [[RelativeDistance]] using
 * a distance propagation formula.
 */
class RelativeRSSIProcessing extends core_1.RelativePositionProcessing {
    constructor(options) {
        super(data_1.RelativeRSSI, options);
        this.options.propagationModel = this.options.propagationModel || PropagationModel.LOG_DISTANCE;
    }
    processRelativePositions(dataObject, relativePositions) {
        return new Promise((resolve) => {
            relativePositions.forEach((relativeObj, relValue) => {
                const distance = this.convertToDistance(relValue, relativeObj);
                if (distance) {
                    dataObject.addRelativePosition(distance);
                }
            });
            resolve(dataObject);
        });
    }
    convertToDistance(rel, transmitter) {
        const environmentFactor = this.options.environmentFactor || transmitter.environmentFactor;
        const calibratedRSSI = transmitter.calibratedRSSI || this.options.defaultCalibratedRSSI;
        switch (this.options.propagationModel) {
            case PropagationModel.LOG_DISTANCE:
                if (calibratedRSSI && rel.rssi && environmentFactor) {
                    const relDistance = new core_1.RelativeDistance(transmitter, Math.pow(10, (calibratedRSSI - rel.rssi) / (10 * environmentFactor)));
                    relDistance.timestamp = rel.timestamp;
                    relDistance.distanceUnit = core_1.LengthUnit.CENTIMETER;
                    return relDistance;
                }
                else {
                    return undefined;
                }
        }
    }
}
exports.RelativeRSSIProcessing = RelativeRSSIProcessing;
var PropagationModel;
(function (PropagationModel) {
    /**
     * Log distance path loss
     * @see {@link https://en.wikipedia.org/wiki/Log-distance_path_loss_model}
     */
    PropagationModel[PropagationModel["LOG_DISTANCE"] = 0] = "LOG_DISTANCE";
})(PropagationModel || (exports.PropagationModel = PropagationModel = {}));
//# sourceMappingURL=RelativeRSSIProcessing.js.map